import { render, staticRenderFns } from "./OrderCardExport.vue?vue&type=template&id=7126b067&scoped=true"
import script from "./OrderCardExport.vue?vue&type=script&lang=ts"
export * from "./OrderCardExport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7126b067",
  null
  
)

export default component.exports